import { Badge } from '../../ui/index.ts';
import { useGame } from '../GameContext.tsx';
import styles from './TeamList.module.css';

export interface TeamListProps {
  /** Shows a small extra mark next to a player (a vote, a pin…). */
  mark?: (playerId: string) => string | null;
  compact?: boolean;
}

/** Everybody at the table with their (public) role. */
export function TeamList({ mark, compact = false }: TeamListProps) {
  const { view, g } = useGame();
  return (
    <ul className={[styles['list'], compact ? styles['compact'] : ''].join(' ')}>
      {view.players.map((p) => {
        const extra = mark?.(p.id) ?? null;
        const mine = p.id === view.you.id;
        // The solo player is already called "You"; online players get the suffix.
        const tag = mine && p.name.toLowerCase() !== g('you').toLowerCase();
        return (
          <li key={p.id} className={[styles['row'], p.expelled ? styles['out'] : ''].join(' ')}>
            <span className={styles['name']}>
              {p.name}
              {tag ? ` (${g('you')})` : ''}
            </span>
            <Badge tone={mine ? 'cyan' : 'neutral'}>{g(`roles.${p.role}`)}</Badge>
            {extra ? <span className={styles['mark']}>{extra}</span> : null}
          </li>
        );
      })}
    </ul>
  );
}
